export const APP_CONSTANTS = {
	APP_VERSION: "2.9",
	PROGRAM_OR_TEMPLATE_MAX_TITLE_LENGTH: 100,
	EXERCISE_MAX_COMMENT_LENGTH: 700,
	HEALTH_CARE_INVITE_MAX_CUSTOM_MESSAGE_LENGTH: 700,
	TOAST_DURATION: 8000, // 8s
	MAX_INPUT_SIZE: "20.625rem",
	PATIENT_APP_ANDROID_STORE: "https://play.google.com/store/apps/details?id=com.biogen.physiome",
	PATIENT_APP_IOS_STORE: "https://apps.apple.com/app/physio-me/id1599700059",
	REGISTRATION_MAX_SIZE_ID_FILE: 5 * 1024 * 1024, // 5 MiB
	REGISTRATION_VALID_MIME_ID_FILE: ["image/jpeg", "image/png", "application/pdf"],
	CUSTOMER_SUPPORT_DEFAULT_EMAIL_KEY: "fr",
	NOTIFICATION_CENTER_PAGINATION_SIZE: 20,
	LEGAL_AGE_DISCLAIMER_COUNTRIES: ["fr"],
};
